import { useTranslation } from 'react-i18next';

import ModalConfirmation from '../../../../shared/ModalConfirmation/ModalConfirmation.jsx';
import { useArchiveCampaignMutation } from './hooks/useCampaignMutation';
import { Modal } from '../../../boardSetup/components/Modals/Modal.jsx';

export const ConfirmArchiveModal = ({
  uuid,
  name,
  showArchiveModal,
  setShowArchiveModal,
}) => {
  const { t } = useTranslation('campaigns');
  const { archiveCampaignMutation } = useArchiveCampaignMutation(uuid);

  return (
    <>
      <Modal open={showArchiveModal} onClose={() => setShowArchiveModal(false)}>
        <ModalConfirmation
          onSave={() => {
            archiveCampaignMutation(uuid);
            setShowArchiveModal(false);
          }}
          onCancel={() => setShowArchiveModal(false)}
          header={t('archiveModal.archiveHeader')}
          body={t('archiveModal.archiveBody', { campaignName: name })}
          variant={'containedRed'}
          answer={t('archiveModal.archiveAnswerValue')}
          actionTitle={t('archiveModal.archiveTooltip')}
          submitText={t('archiveModal.archiveButton')}
          cancelText={t('archiveModal.cancelButton')}
        />
      </Modal>
    </>
  );
};
